export const LANGUAGE_FOR_OS = {
  EN: 'en-US',
  KOKR: 'ko-KR',
  KO: 'ko',
};
